module.exports = __webpack_public_path__ + "static/media/bg_left.8a9089b0.png";